import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output, ViewChild, ElementRef, OnDestroy, HostListener, AfterViewInit, ViewChildren, Renderer2 } from '@angular/core';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { DetailService } from '../services/detail.service';
import { ConfirmationService } from '../services/confirmation.service';
import { Detail, DetailPropertyGroup, DetailProperty, DetailSection, Action, ValueSelection, CombinationProperty } from '../objects/DetailObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NgForm } from '@angular/forms';
import { trigger, state, style, animate, transition} from '@angular/animations';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';
import { of, Subscription, Observable, BehaviorSubject, Subject } from 'rxjs';
import { WorkspaceService } from '../services/workspace.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material';
import { MyTreeNode } from '../objects/TreeviewObject';
import { HeaderService } from '../services/header.service';
import { EnvService } from '../env.service';
import { AttachmentService } from '../services/attachment.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { MessagePopupService } from '../services/message-popup.service';
import { debounceTime } from 'rxjs/operators';
import { IInfiniteScrollEvent } from 'ngx-infinite-scroll';
import { SessionTimerService } from '../services/session-timer.service';
import { FloatingPanelService } from '../services/floating-panel.service';
import { SidePopupService } from '../services/side-popup.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1
      })),
      state('closed', style({
        opacity: 0
      })),
      transition('open => closed', [
        animate('50ms')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
    trigger('hideShow', [      
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),
      transition(':leave', [
        animate(300, style({ opacity: 0 }))
      ]),
      state('*', style({ opacity: '1' })),
    ])
  ]
})

export class DetailComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.hiddenActions && this.btnShowMore){
      if (this.hiddenActions.nativeElement.contains(event.target) || this.btnShowMore.first.nativeElement.contains(event.target)){

      }
      else{
        this.showHidden = false;
      }
    }
  }

  onScroll(event) {
    // if (this.isPopupDetail){
      this.scrollEvent = event;
      if (this.detailProperties){
        this.detailProperties.forEach(element => {
          element.IsDropdownOpen = false;
        });
      }
      
      if (this.combinationProperty){
        this.combinationProperty.forEach(list => {
          list.properties.forEach(prop => {
            prop.IsDropdownOpen = false;
          })
        })
      }
    // }
  }

  public readonly loadingPreview: BehaviorSubject<boolean> = new BehaviorSubject(false);
  next: Subject<any> = new Subject();
  showEmpty:boolean = false;

  @Input() set setComponentId(id:any) {
    if (id){
      this.showEmpty = false;
      if (id == 1){ // default input to cancel loading
        this.animate = true;
        this.isBusy = false;
      }
      else{
        this.errorMessage = "";
        this.componentId = id;
        this.isBusy = true;
        if (this.sub) this.sub.unsubscribe();
        this.getDetailCard();
        
      }
    }
    else if (id == 0){ // default emit to show loading
      this.animate = false;
      this.isBusy = true;
      this.showEmpty = false;
    }
    else{
      this.showEmpty = true;
    }
  }

  @Input() set forceRefresh(isTrue:boolean){
    if(this.globals.Session){
      this.getDetailCard();
    }
  }

  @Input() set setSubDetail(obj: any){
    if (!this.autoRefresh) this.isBusy = true;
    this.detailService.getNewDetailFromPropertyGroup(obj.DetailId, obj.PropertyGroupId).subscribe(id => {
      if (id){
        this.componentId = id;
        this.getDetailCard();
      }
      else{
        this.isBusy = false;
      }
    });
  }

  @Input() set actionOnDetail(action: Action){
    if (action){
      this.onDetailAction(action, this.detailForm, true)
    }
  }

  @Input() set parentScroll(scrollEvent: any){
    if (scrollEvent){
      this.onScroll(scrollEvent);
    }
  }

  @Input() set triggerFocus(focus: boolean){
    if (this.detailObject){
      var properties = this.sortPropertiesByGroup();
      for (let i in properties){
        if (this.detailForm.control.get(properties[i].PropertyName)){
          if (this.detailForm.control.get(properties[i].PropertyName).invalid){
            if (this.detailObject.Groups.filter(x => x.GroupId == properties[i].PropertyGroupId).length > 0){
              this.detailObject.Groups.find(x => x.GroupId == properties[i].PropertyGroupId).IsExpanded = true;
              this.hiddenPropertyFocus = properties[i];
            }
            else{
              this.hiddenPropertyFocus = null;
              this.detailService.setPropertyFocus(properties[i].PropertyId);
            }
            break;
          }
        }
      }
    }
  }

  @Input() documentType:string;
  @Input() isSubDetail: boolean = false;
  @Input() isPreview: boolean = false;
  @Input() isPopupDetail:boolean = false;
  @Input() autoRefresh: boolean = false;
  @Input() displayDetail: boolean = true;
  @Input() fromBroadcast: boolean = false;
  @Input() hideSection: boolean = false;

  @Output() selectedSubItemId = new EventEmitter<string>();
  @Output() selectedSubItemType = new EventEmitter<string>();
  @Output() updateAll = new EventEmitter<boolean>();
  @Output() docId = new EventEmitter<boolean>();
  @Output() refreshPopup = new EventEmitter<string>();
  @Output() hidePopup = new EventEmitter<boolean>();
  @Output() title = new EventEmitter<string>();
  @Output() loadingPopup = new EventEmitter<boolean>();
  @Output() subSelectedId = new EventEmitter<string>();
  @Output() subForm = new EventEmitter<any>();
  @Output() detailActions = new EventEmitter<Action[]>();
  @Output() propertyValueChanged = new EventEmitter<string>();
  @Output() emitProperty = new EventEmitter<string>();

  @ViewChild('title') public titleElem;
  @ViewChild('group') public groupContainer: ElementRef;
  @ViewChild('subcontainer') public subContainer: ElementRef;
  @ViewChild('detailForm') public detailForm: NgForm;
  @ViewChild('detailContainer') public detailContainer: ElementRef;
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  @ViewChild('hiddenActions') public hiddenActions: ElementRef;
  @ViewChildren('btnShowMore') public btnShowMore: any;
  @ViewChild('detailHeader') public detailHeader: ElementRef;
  @ViewChild('actionGroup') public actionGroup: ElementRef;
  @ViewChild('actionContainer') public actionContainer: ElementRef;
  @ViewChild('subActionContainer') public subActionContainer: ElementRef;
  @ViewChild('previewLoading') public previewLoading: ElementRef;

  private documentId:string;
  private isDebug: boolean;
  private hideCheckbox: boolean = true;
  private animate:boolean = true;
  componentId:string;
  isBusy:boolean = false;
  detailObject:Detail;
  errorMessage: string;
  //private isPopupDetail: boolean = false;
  private stateDisplayType: string;
  modalRef: BsModalRef;
  private selectedSection:string;
  private submitted: boolean = false;
  private detailProperties:DetailProperty[];
  private hiddenProperties:DetailProperty[] = [];
  private tempDetailProperties: DetailProperty[];
  private combinationProperty: CombinationProperty[];
  private fixedMessageList:Object = new Object();
  private sectionStatus:Object = new Object();
  private animation:boolean = false;
  private sections:DetailSection[] = [];
  private groups:DetailPropertyGroup[] = [];
  private actions:Action[] = [];
  private loaderConfig :any;
  private checkSummaryUpdate:boolean = false;
  private updateChild:boolean = false;
  private propertyUpdate: DetailProperty;
  private previousComponentId: string;
  private subscription: Subscription;
  private subForms:any = {};
  private sub: Subscription;
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;
  private timer;
  private isSticky:boolean = false;
  private currentHierarchyId: string;
  private lookupArray = [];
  private hiddenList = [];
  private hiddenPropertyFocus: DetailProperty;
  private actionsReady: boolean = false;
  private loadingNextPreview: boolean = false;
  private lastPreview: boolean = false;
  private hideDetailHeader: boolean = false;
  nextPreview: boolean = false;
  hasGroupLoading: boolean = false;
  showBtnMore: boolean = false;
  showHidden: boolean = false;
  noLoading: boolean = false;
  detailScrollPoint: number;
  scrollEvent: any;

  private treeNodes:MyTreeNode[] = [];
  treeControl: NestedTreeControl<MyTreeNode>;
  treeDataSource: MatTreeNestedDataSource<MyTreeNode>;

  constructor(private globals:Globals, 
    private detailService:DetailService,
    private attachmentService: AttachmentService,
    private confirmationService: ConfirmationService, 
    private router:Router,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private toasterMessageService: ToasterMessageService,
    private workflowReturnService: WorkflowReturnService,
    private themeSettingService: ThemeSettingService,
    private workspaceService:WorkspaceService,
    private contextMenuService: ContextMenuService,
    private headerService: HeaderService,
    private env: EnvService,
    private render: Renderer2,
    private messagePopupService: MessagePopupService,
    private sessionTimerService: SessionTimerService,
    private eRef: ElementRef,
    private floatingPanelService: FloatingPanelService,
    private sidePopupService: SidePopupService) { 
      this.isDebug = this.env.enableDebug;
      this.sub1 = this.workspaceService.currentParentIdChanged$.subscribe(id => {
        if (this.componentId == id){
          this.isBusy = true;
          this.getDetailCard();
        }
      });

      this.sub2 = this.detailService.treeDataChanged.subscribe(result => {
        if (result){
          let index = this.lookupArray.indexOf(x => x.name == result.name);
          if (index < 0){
            this.lookupArray.push(result);
          }
          else{
            this.lookupArray[index] = result;
          }
        }
      })

      this.sub3 = this.detailService.loadMoreChanged.subscribe(result => {
        if (this.lookupArray.length > 0){
          let currentLookup = this.lookupArray.find(x => x.name == result.name);
          if (currentLookup){
            let index = this.lookupArray.findIndex(x => x.name == result.name);
            if (index > -1){
              this.constructHierarchy(this.detailProperties.find(x => x.PropertyName == result.name), currentLookup.data.slice(0, (result.page * 100)))
            }
          }
        }
      });

      this.sub4 = this.workflowReturnService.isLoadingHomeChanged.subscribe(result => {
        if (result) {
          this.isBusy = true;
        }
        else{
          this.isBusy = false;
        }
      });
      // this.treeControl = new NestedTreeControl<MyTreeNode>(this.makeGetChildrenFunction());
      // this.treeDataSource = new MatTreeNestedDataSource();
      // this.treeDataSource.data = this.treeNodes;
  }

  ngOnInit() {
    let themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    if(this.documentId){
      this.getDetailCard();
    }

    this.next.pipe(
      debounceTime(100)
    ).subscribe(result => {
      if (!this.loadingNextPreview && !this.lastPreview){
        this.nextPreview = true;
        this.getPreviewNextSection(event);
      }
    })
  }

  ngOnDestroy(){
    if (this.sub) this.sub.unsubscribe();
    if (this.sub1) this.sub1.unsubscribe();
    if (this.sub2) this.sub2.unsubscribe();
    if (this.sub3) this.sub3.unsubscribe();
    if (this.sub4) this.sub4.unsubscribe();

    this.sessionTimerService.setKeepSessionAlive(false);
  }

  private makeGetChildrenFunction() {
    return node => of(node.children)
  }

  hasChildren = (_: number, node: MyTreeNode) => {
    // return node.children && node.children.length > 0;
    return node.hasChild;
  }

  loadMore = (_: number, node: MyTreeNode) => {
    return node;  
  }

  checkIfHasError(id: string): boolean{
    let noError = true;
    if (id){
      if(id.startsWith("ERROR:")){
        noError = false;
        this.componentId = "";
        this.errorMessage = id.substr(6, id.length - 1);
        this.isBusy = false;
      }
      else{
        noError = true;
      }
    }
    else{
      noError = false;
      this.isBusy = false
    }
    return noError;
  }

  getDetailCard():void{
    if (this.checkIfHasError(this.componentId)){
      if(this.componentId){
        this.detailService.getCurrentSection(this.componentId).subscribe(section=>{
          this.selectedSection = section;
        });
        this.detailService.getDetail(this.componentId).subscribe(cardResult=> {
          this.detailObject = JSON.parse(cardResult);
          // console.log(JSON.parse(cardResult));
          this.propertyUpdate = null;
          this.title.emit(this.detailObject.DocTitle);
          this.detailService.isNewDetail(true);
          this.submitted = false;
          this.combinationProperty = [];
          this.hiddenList = [];
          if (this.detailObject){
            this.detailProperties = this.detailObject.Properties.filter(x => x.PropertyOrder != 0).filter(x => !x.PropertyIsHidden);
            this.hiddenProperties = this.detailObject.Properties.filter(x => x.PropertyOrder == 0);
            this.sortProperties();
            this.sortPropertySections();
            this.sortDetailActions();
            this.formatPropertyGroups();
            this.handleDetailHeader();
            this.sectionStatus = {};
            this.currentHierarchyId = null;
            this.detailActions.emit(this.actions);

            this.detailObject.Sections.forEach(element => {
              if (element.ValidationStatus == "-1"){
                this.detailService.getSectionStatus(this.componentId, element.SectionId).subscribe(result=>{
                  if(result){
                    this.sectionStatus[element.SectionId] = result;
                  }
                });
              }
              else {
                this.sectionStatus[element.SectionId] = element.ValidationStatus;
              }
            });

            if (this.detailObject.Properties.filter(x => x.PropertyFormControlType.toUpperCase() == "EMIT").length > 0){
              this.emitProperty.emit(this.detailObject.Properties.find(x => x.PropertyFormControlType.toUpperCase() == "EMIT").PropertyValue);
            }
            else if (this.detailObject.Properties.filter(x => x.PropertyFormControlType.toUpperCase() == "KEEPSESSIONALIVE").length > 0){
              this.handleSessionProperty(this.detailObject.Properties.find(x => x.PropertyFormControlType.toUpperCase() == "KEEPSESSIONALIVE"));
            }

            this.formatProperties();

            if (this.detailObject.StateDisplayType == "ProcessingDetail" || this.detailObject.StateDisplayType == "ProcessingSectionDetail"){
              this.checkDetailUpdate();
            }
            else if (this.detailObject.StateDisplayType == "ProcessingActionLeft" || this.detailObject.StateDisplayType == "ProcessingSimple"){
              this.checkDetailUpdate();
              this.detailObject.DocTitle = "";
              this.detailObject.DocSubtitle = "";
            }
            else if (this.detailObject.StateDisplayType == "Simple"){
              this.detailObject.DocTitle = "";
              this.detailObject.DocSubtitle = "";
            }
            else{
              if (this.sub) this.sub.unsubscribe();
            }

            this.detailObject.IsAutoLoad = this.noLoading;

            this.previousComponentId = this.componentId;
            this.stateDisplayType = this.detailObject.StateDisplayType;
            this.isBusy = false;
            this.loadingPopup.emit(false);
            this.animate = true;
            this.noLoading = false;
            //this.scrollToTop();
          }
        }, error => {
          this.isBusy = false;
          this.noLoading = false;
          if (this.sub) this.sub.unsubscribe();
        });
      }else{
        this.animate = true;
        this.isBusy = false;
      }
    }
  }

  handleDetailHeader(){
    if ((this.actions.length == 0 && !this.detailObject.DocTitle && !this.detailObject.DocSubtitle)
     || this.detailObject.StateDisplayType == "ActionBottom" || this.detailObject.StateDisplayType == "ProcessingSimple"
     || this.detailObject.StateDisplayType == "Simple" || this.isPopupDetail) {
      this.hideDetailHeader = true;
    }
    else{
      this.hideDetailHeader = false;
    }
  }

  formatProperties(isTempProperties: boolean = false){
    let detailProperties = this.detailProperties;
    if (isTempProperties) detailProperties = this.tempDetailProperties;

    detailProperties.forEach(element => {
      if (element.PropertyFormControlType.toUpperCase() == "MULTITEXT"){
        if (element.PropertyValueArray){
          let a:ValueSelection[] = [];
          element.PropertyValueArray.forEach(value => {
            let b:ValueSelection = {SelectionValue: value, SelectionDisplay: value, SelectionMapValue: value, GroupBy: null, IsSelected: false, HasChild: false};
            a.push(b);
          });
          element.PropertyValueSelection = a;
          this.getLookupList(element);
        }
      }
      else if(element.PropertyFormControlType.toUpperCase() == "FIXEDMESSAGE"){
        this.getFixedMessage(element.PropertyId);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "COMBINATION"){
        this.constructCombinationProperty(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == 'FIXEDFILE'){
        this.downloadFixedFile(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "PDFVIEWER"){
        this.downloadPdfFile(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "COUNTDOWN"){
        this.handleCountdownProperty(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT"){
        element.PropertyValueArray = [];
        if (element.PropertyValue){
          element.PropertyValueArray = [element.PropertyValue];
        }
        this.getHierarchy(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT"){
        this.getHierarchy(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX"){
        this.getLookupList(element);
      }
      else if (element.PropertyFormControlType.toUpperCase() == "DATE" || element.PropertyFormControlType.toUpperCase() == "DATETIME"){
        this.handleMinMaxDate(element, detailProperties);
      }

      if (element.ParentPropertyName){
        if (this.detailProperties.find(x => x.PropertyName == element.ParentPropertyName)){
          if (this.detailProperties.find(x => x.PropertyName == element.ParentPropertyName).PropertyFormControlType.toUpperCase() == "OPTIONALMULTIPLEFILES"
              || this.detailProperties.find(x => x.PropertyName == element.ParentPropertyName).PropertyFormControlType.toUpperCase() == "OPTIONALFILE"){
                element.PropertyClientIsHidden = true;
          }
          this.detailProperties.find(x => x.PropertyName == element.ParentPropertyName).ChildPropertyName = element.PropertyName;
        }
      }
    });
  }

  handleMinMaxDate(element: DetailProperty, detailProperties: DetailProperty[]){
    if (element.PropertyValidation){
      if (element.PropertyValidation.MinValue){
        if (element.PropertyValidation.MinValue.indexOf("{") > -1){
          var matchProp = detailProperties.find(x => x.PropertyName == element.PropertyValidation.MinValue.replace("{", "").replace("}", ""));
          if (matchProp){
            element.PropertyValidation.MinValue = matchProp.PropertyValue;
          }
          
        }
      }

      if (element.PropertyValidation.MaxValue){
        if (element.PropertyValidation.MaxValue.indexOf("{") > -1){
          
        }
      }
    }
  }

  scrollToTop(){
    if ((this.stateDisplayType != 'MultiSectionDetail' && this.stateDisplayType != 'ProcessSectionDetail') || this.isPopupDetail){
      if (this.subContainer) {
        this.subContainer.nativeElement.scrollTop = 0;
      }
    }
    else{
      if (this.groupContainer) this.groupContainer.nativeElement.scrollTop = 0;
    }
  }

  checkDetailUpdate(){
    if (this.sub) this.sub.unsubscribe();
    
    let timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
    this.sub = timer.subscribe(t => this.checkIfHasUpdate());
  }

  formatPropertyGroups(){
    
    this.detailObject.Groups.forEach(group => {
      // get group actions
      group.GroupActions = [];
      group.GroupActions = this.detailObject.Actions.filter(x => x.DisplayOnGroup == group.GroupId).filter(x => !x.IsHidden);

      if (group.GroupFormat.indexOf('ACCORDION') > -1){
        if (group.GroupFormat.indexOf('OPEN') > -1){
          group.IsExpanded = true;
        }
      }
      group.InitialLoad = true;
    })
    
    this.sortPropertyGroups();
  }

  retrieveCombobox(propertyName:string){
    this.detailService.getLookupList(this.componentId, propertyName).subscribe(result=> {
      let lookupList:ValueSelection[] = JSON.parse(result);
      //this.detailObject.Properties.find(x=> x.PropertyName == propertyName).ValuesSelection = lookupList;
      // this.detailObject.Properties.find(x => x.PropertyName == propertyName).ValuesSelection.forEach(element => {
        // element.SelectionValue = element.SelectionValue.toLowerCase();
        // element.SelectionMapValue = element.SelectionValue;
        // console.log(this.detailObject.Properties.find(x=> x.PropertyName == propertyName).ValuesSelection);
      // });
    });
  }

  refreshDetail(event){
    this.isBusy = true;
    this.getDetailCard();
  }

  updateForm(prop:DetailProperty){
    this.detailForm.control.get(prop.ParentPropertyName).setErrors({noMatch: true});
  }

  getPropertyWidth(propertyId: string, order: number):any {
    if (order == 0){
      return this.combinationProperty.find(x => x.combinationId == propertyId).columnWidth[0].initialColumnWidth;
    }else{
      return this.combinationProperty.find(x => x.combinationId == propertyId).columnWidth[0].secColumnWidth;
    }
  }

  getDate(date: string, format: string): string{
    if (!format){
      format = "dd/MM/yyyy";
    }
    if (!date){
      return date;
    }
    else{
      return new DatePipe("en-US").transform(new Date(date), format);
    }
    
  }

  onSelectedItem(selectedId:string) {
    this.subSelectedId.emit(selectedId);
    if (this.isPopupDetail){
      this.openPopup(selectedId, "");
    }
  }

  onValueChange(event){
    this.propertyValueChanged.emit(event);
    if (this.isPopupDetail){
      this.openPopup(event, "");
    }
  }

  downloadFixedFile(property:DetailProperty){
    if (property.PropertyDisplayFormat){
      let fileList = property.PropertyDisplayFormat.split(',');
      property.PropertyFixedFileUrl = [];
      fileList.forEach(file => {
        this.attachmentService.downloadFile(file.split('|')[1]).subscribe(data=>{
          property.PropertyFixedFileUrl.push(this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data)));
        });
      });
    }
  }

  downloadPdfFile(property:DetailProperty){
    if (property.PropertyValue){
      this.attachmentService.downloadFile(property.PropertyValue).subscribe(data=>{
        property.PropertyFixedFileUrl = [];
        property.PropertyFixedFileUrl.push(data);
      });
    }
  }

  handleSessionProperty(property: DetailProperty){
    this.sessionTimerService.setKeepSessionAlive(true);
  }

  handleCountdownProperty(property: DetailProperty){
    if (property.ParentPropertyName){
      let prop = this.detailObject.Properties.find(x => x.PropertyName == property.ParentPropertyName);
      if (prop){
        property.ParentPropertyValue = prop.PropertyValue;
      }
    }
  }
  
  openPopup(event, title: string, isPreview:boolean = false) {
    let popupClass = "modal-dialog-centered modal-detail";
    if(isPreview) popupClass += " modal-preview";

    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: popupClass,
      initialState: {
        componentId: event,
        title: title,
        isPreview: isPreview
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
      else{
        this.isPopupDetail = false;
      }
    })

    this.modalRef = this.modalService.show(DetailPopupComponent, config);
  }

  onRefreshAll(isUpdate:boolean){
    this.getDetailCard();
    this.updateAll.emit(true);
  }

  handleDateTimeProperty(form: NgForm){
    this.detailProperties.filter(x => x.PropertyFormControlType.toUpperCase() == 'DATETIME').forEach(prop => {
      if (!prop.PropertyValidation && prop.PropertyIsEditable){
        if (form.controls[prop.PropertyName]){
          form.controls[prop.PropertyName].setErrors(null);
        }
      }
      else if (prop.PropertyValidation && prop.PropertyIsEditable){
        if (prop.PropertyValidation.MinValue == "@CURRENTDATETIME"){
          var date = new Date();
          if (prop.PropertyValue){
            var value = new Date(prop.PropertyValue);
            var date = new Date();
            if (date < value){
              // check if only dateMin error is present
              if (form.controls[prop.PropertyName].errors){
                if (form.controls[prop.PropertyName].errors.DateMin || form.controls[prop.PropertyName].errors.matDatepickerMin) {
                  form.controls[prop.PropertyName].setErrors(null);
                }
              }
              
            }
            else if (date > value){
              form.controls[prop.PropertyName].markAsDirty();
              form.controls[prop.PropertyName].setErrors({DateMin: true});
            }
          }
        }
      }
    });
    return form;
  }

  onDetailAction(action:Action, form: NgForm, scrollToTop:boolean){
    this.animate = false;
    if (this.detailProperties.filter(x => x.PropertyFormControlType.toUpperCase() == 'DATETIME').length > 0){
      form = this.handleDateTimeProperty(form);
    }

    if (action.TriggersSubAction){
      // SAMPLE :- SubmitProfile|FORM_SAVE
      let formName = action.TriggersSubAction.split('|')[0];
      let actionCommand = action.TriggersSubAction.split('|')[1];
      if(this.subForms[actionCommand]){
        let status = this.subForms[formName];
        if (status == "VALID"){
          this.runValidation(action, form, scrollToTop);
        }
        else{
          this.groups.find(x => x.GroupName == formName).TriggerFocus = !this.groups.find(x => x.GroupName == formName).TriggerFocus;
        }
      }
      else{
        this.runValidation(action, form, scrollToTop);
      }
    }
    else{
      this.runValidation(action, form, scrollToTop);
    }
  }

  runValidation(action: Action, form:NgForm, scrollToTop: boolean){
    if (action.TriggersValidation){
      if (form.valid){
          // if (scrollToTop){
          //   this.scrollToTop();
          // }
          this.handlePrompt(action);
      }
      else{
        this.submitted = true;
        var properties = this.sortPropertiesByGroup();

        for (let i in properties){
          if (form.control.get(properties[i].PropertyName)){
            if (form.control.get(properties[i].PropertyName).invalid){
              if (this.detailObject.Groups.filter(x => x.GroupId == properties[i].PropertyGroupId).length > 0){
                this.detailObject.Groups.find(x => x.GroupId == properties[i].PropertyGroupId).IsExpanded = true;
              }
              this.detailService.setPropertyFocus(properties[i].PropertyId);
              break;
              
            }
          }
        }
      }
    }
    else{
      // if (scrollToTop){
      //   this.scrollToTop();
      // }
      this.handlePrompt(action);
    }
  }

  handlePrompt(action: Action){
    if (action.TriggersPrompt){
      switch(action.PromptType){
        case "Yes|No":
          this.isBusy = true;
          this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(result => {
            if (result){
              this.handleWorkflowReturn(result);
            }
            else{
              this.isBusy = false;
              this.confirmationService.confirm(
                "Confirmation",
                action.PromptMessage.split('|')[0],
                ["CANCEL", "OK"])
                .subscribe((respond) => {
                  if (respond.answer == "OK"){
                    this.detailAction(action);
                  }
              });
            }
          }, error => {
            this.isBusy = false;
          });
        break;
        case "TypeToConfirm":
          this.isBusy = true;
          this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(result => {
            if (result){
              this.handleWorkflowReturn(result);
            }
            else{
              this.isBusy = false;
              this.confirmationService.confirm(
                action.PromptMessage.split('|')[0],
                "",
                ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
                .subscribe((respond) => {
                  if (respond.answer == "OK"){
                    this.detailAction(action);
                  }
                });
              }
            }, error => {
              this.isBusy = false;
            });
          break;
        case "OK":
          this.isBusy = true;
          this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(result => {
            if (result){
              this.handleWorkflowReturn(result);
            }
            else{
              this.isBusy = false;
              this.messagePopupService.popMessage("", action.PromptMessage.split('|')[0], ["OK"]).subscribe((respond) => {
                if (respond.answer == "OK"){
                  this.detailAction(action);
                }
              });
            }
          }, error => {
            this.isBusy = false;
          });
        break;
        case "Preview":
        this.isBusy = true;
        this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(result => {
          if (result){
            this.handleWorkflowReturn(result);
          }
          else{
            this.detailService.getPreview(this.componentId, action.ActionCommand).subscribe(previewId=>{
              this.isBusy = false;
              this.openPopup(previewId, action.PromptMessage.split('|')[0], true);
            });
          }
        }, error => {
          this.isBusy = false;
        });
        break;
      }
    }
    else{
      this.detailAction(action);
    }
  }

  detailAction(action:any) {
    this.animate = false;
    if (this.isPopupDetail){
      this.loadingPopup.emit(true);
    }
    else{
      this.isBusy = true;
    }
    
    var pendingUpdates = this.detailService.getPendingUpdate();
    if (pendingUpdates.length > 0){
      var formattedObj = [];
      pendingUpdates.forEach(updateObj => {
        formattedObj.push({name: updateObj.property.PropertyName, value: updateObj.value})
      });
      
      this.promiseUpdates(formattedObj).then(result => {
        this.detailService.clearPendingUpdate();
        this.detailService.detailAction(this.componentId, action.ActionCommand).subscribe(result=> {
          this.handleWorkflowReturn(result);
    
        }, error => {
          if (this.isPopupDetail){
            this.loadingPopup.emit(false);
          }
          else{
            this.isBusy = false;
          }
        });
      });
    }
    else{
      this.detailService.detailAction(this.componentId, action.ActionCommand).subscribe(result=> {
        this.handleWorkflowReturn(result);
  
      }, error => {
        if (this.isPopupDetail){
          this.loadingPopup.emit(false);
        }
        else{
          this.isBusy = false;
        }
      });
    }
  }

  promiseUpdates(formattedObj: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      var returnObj: any;
      this.detailService.updateMultiFields(this.componentId, formattedObj).subscribe(results => {
        returnObj = results;
        resolve(returnObj);
      });
    });
  }

  handleWorkflowReturn(result: any): any {
    let command = JSON.parse(result);
    this.workflowReturnService.handleWorkflowReturn(command);

    if (command.ReturnType != 10 && (command.RefreshType == "self" || command.RefreshType == "none")){
      this.animate = true;
      if (this.isPopupDetail){
        this.loadingPopup.emit(false);
      }
      else{
        this.isBusy = false;
      }
    }

    //this.currentSelectedLookup = null;
    switch(command.RefreshType){
      case "self": this.getDetailCard(); break;
      case "parent":
        this.isBusy = true;
        this.getDetailCard();
        this.getEPICParent(false, command.ReturnType, command.IsPreview);
        break;
      case "all":
        this.getDetailCard();
        this.getEPICParent(true, command.ReturnType, command.IsPreview);
      break;
    }
  }

  getEPICParent(findAllParent:boolean, returnType:number, isPreview: boolean = false){
    if (findAllParent){
      this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(result => {
        this.handlePopup(returnType, isPreview);
        if (result){
          let array = JSON.parse(result);
          array.forEach(id => {
            this.workspaceService.setParentId(id);
          });
        }
      }, error => {
        this.handlePopup(returnType, isPreview);
      })
    }
    else{
      this.workspaceService.getParentEPICId(this.componentId).subscribe(result => {
        this.workspaceService.setParentId(result);
        this.handlePopup(returnType, isPreview);
      }, error => {
        this.handlePopup(returnType, isPreview);
      })
    }
  }

  handlePopup(returnType, isPreview: boolean = false){
    if (returnType == 4 || isPreview){
      this.hidePopup.emit(true);

      this.animate = true;
      if (this.isPopupDetail){
        this.loadingPopup.emit(false);
      }
      else{
        this.isBusy = false;
      }
    }
  }

  hidesAllModals(){
    if (this.confirmationService.bsModalRef){
      this.confirmationService.bsModalRef.hide();
    }
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    document.body.classList.remove('modal-open');
    this.sidePopupService.removePopup();
  }

  handleNavigateAndMessage(command:any, hasSession:boolean = false){
    let path = [];
    let newArgs = command.Arguments.splice(2);
    newArgs.forEach(element => {
      path.push(element);
    });
    
    if (hasSession){
      // close all popups
      for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
        this.modalService.hide(i);
      }
      document.body.classList.remove("modal-open");

      this.router.navigate(path);
      this.headerService.setSelectedMenu('clearSelected');
      this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
    }
  }

  downloadFile(blob: any, fileName:string): void {
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  showLoading($event, scrollToTop){
    if ($event){
      this.animate = false;
      if (this.isPopupDetail){
        this.loadingPopup.emit(true);
      }
      else {
        this.isBusy = true;
      }
    }
    else{
      if (this.isPopupDetail){
        this.loadingPopup.emit(false);
      }
      else {
        this.isBusy = false;
      }
    }
    // if (scrollToTop){
    //   this.scrollToTop();
    // }
  }

  changeSection(sectionId:string){
    this.isBusy = true;
    this.animate = false;
    this.submitted = false;
    this.detailService.changeSection(this.componentId, sectionId).subscribe(result=>{
      if(result == "1"){
        this.getDetailCard();
      }
    });
  }

  getFixedMessage(propertyId:string)
  {
    this.detailService.getFixedMessageText(this.componentId, propertyId).subscribe(result=> {
      this.fixedMessageList[propertyId] = result; 
    });
  }

  sortPropertyGroups(){
    this.hasGroupLoading = this.detailObject.Groups.filter(x => x.GroupType == 'Loading').length == 0 ? false : true;
    this.groups = this.detailObject.Groups.sort((a:DetailPropertyGroup,b:DetailPropertyGroup) => { 
      if(a.GroupOrder > b.GroupOrder){
        return 1;
      }else if(a.GroupOrder < b.GroupOrder){
        return -1;
      }else{
        return 0;
      }
     });
  } 

  sortDetailActions(){
    this.actions = this.detailObject.Actions.sort((a:Action,b:Action) => { 
      if(a.ActionOrder > b.ActionOrder){
        return 1;
      }else if(a.ActionOrder < b.ActionOrder){
        return -1;
      }else{
        return 0;
      }
     }).filter(x => !x.IsHidden).filter(x => !x.DisplayOnGroup);
  }

  sortPropertySections(){
    this.sections = this.detailObject.Sections.sort((a:DetailSection,b:DetailSection) => { 
      if(a.SectionOrder > b.SectionOrder){
        return 1;
      }else if(a.SectionOrder < b.SectionOrder){
        return -1;
      }else{
        return 0;
      }
     });
  } 

  getLookupList(property: DetailProperty){
    property.PropertyValueDisplayArray = [];
    if (property.PropertyValueArray){
      property.PropertyValueArray.forEach(value => {
        if (property.PropertyValueSelection){
          if(property.PropertyValueSelection.length > 0){
            if(property.PropertyValueSelection.find(x=> x.SelectionValue == value)){
              property.PropertyValueDisplayArray.push(property.PropertyValueSelection.find(x=> x.SelectionValue == value).SelectionDisplay);
            }
          }
          else{
            property.PropertyValueDisplayArray.push(value);
          }
        }
      })
    }
  }

  getHierarchy(property: DetailProperty){
    this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeControl = new NestedTreeControl<MyTreeNode>(this.makeGetChildrenFunction());
    this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeDataSource =  new MatTreeNestedDataSource();
    this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeDataSource.data = [];
    if (!property.PropertyValueSelection){
      // this.detailService.getLookupList(this.componentId, property.PropertyName).subscribe(result=> {
      //   let lookupList:ValueSelection[] = JSON.parse(result);
      //   this.detailObject.Properties.find(x=> x.PropertyId == property.PropertyId).PropertyValueSelection = lookupList;
      //   this.constructHierarchy(property);       
      // });
    }
    else{
      this.detailProperties.find(x => x.PropertyId == property.PropertyId).PropertyOriginalValueSelection = property.PropertyValueSelection;
      this.constructHierarchy(property, property.PropertyValueSelection);
    }
  }

  showHierarchy(property: DetailProperty, show: boolean){
    if (this.detailProperties.find(x => x.PropertyId == property.PropertyId)){
      let prop = this.detailProperties.find(x => x.PropertyId == property.PropertyId);
      if (show && property.PropertyId != this.currentHierarchyId){
        prop.PropertyLoadHierarchy = true;
        this.detailService.getLookupList(this.componentId, property.PropertyName).subscribe(result=> {
          let lookupList:ValueSelection[] = JSON.parse(result);
          this.detailService.setTreeData({name: property.PropertyName, data:lookupList});
          lookupList = lookupList.slice(0, 100);
          this.detailObject.Properties.find(x=> x.PropertyId == property.PropertyId).PropertyValueSelection = lookupList;
          this.constructHierarchy(property, lookupList);
          if (property.PropertyValueArray){
            this.getLookupList(property);
            //this.expandIfSelected(property);
          }
          prop.PropertyShowHierarchy = !prop.PropertyShowHierarchy;
          this.currentHierarchyId = property.PropertyId;
          prop.PropertyLoadHierarchy = false;
        }, error => {
          prop.PropertyLoadHierarchy = false;
        });
      }
      else{
        prop.PropertyShowHierarchy = !prop.PropertyShowHierarchy;
      }
    }
  }

  expandIfSelected(prop: DetailProperty){
    prop.PropertyOriginalValueSelection.forEach(element => {
      if (element.GroupBy) {
        
      }
    });
  }

  constructHierarchy(property: DetailProperty, lookup: any){
    let nodes:MyTreeNode[] = [];
    let treeNodes: MyTreeNode[] = [];
    if (lookup){
      // property.PropertyValueSelection.forEach(element => {
      //   if (property.PropertyValueArray){
      //     if(property.PropertyValueArray.indexOf(element.SelectionValue) > -1){
      //       element.IsSelected = true;
      //     }
      //   }
      //   nodes.push({
      //     id: element.SelectionValue,
      //     title: element.SelectionDisplay,
      //     isSelected: element.IsSelected,
      //     parent: element.GroupBy
      //   });
      // });

      // property.PropertyValueSelection.forEach(element => {
      //   if (!element.GroupBy) {
      //     let tree = this.getNestedChildren(nodes, element.SelectionValue);
      //     treeNodes.push({
      //       id: element.SelectionValue,
      //       title: element.SelectionDisplay,
      //       isSelected: element.IsSelected,
      //       children: tree
      //     });
      //   }
      // });

      lookup.forEach(element => {
        if (property.PropertyValueArray){
          if(property.PropertyValueArray.indexOf(element.SelectionValue) > -1){
            element.IsSelected = true;
          }
        }

        treeNodes.push({
          id: element.SelectionValue,
          title: element.SelectionDisplay,
          isSelected: element.IsSelected,
          hasChild: element.HasChild
        })
      })

      if (treeNodes.length > 0) {
        if (this.lookupArray.find(x => x.name == property.PropertyName)){
          if (treeNodes.length != this.lookupArray.find(x => x.name == property.PropertyName).data.length){
              treeNodes[treeNodes.length - 1].hasLoadMore = true;
            }
        }
      }
      
      this.getLookupList(property);
      this.detailProperties.find(x=> x.PropertyId == property.PropertyId).PropertyValueSelection = lookup;
      this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeControl.dataNodes = treeNodes;
      this.detailProperties.find(x => x.PropertyId == property.PropertyId).treeDataSource = new MatTreeNestedDataSource<MyTreeNode>();
      this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeDataSource.data = treeNodes;
    }
  }

  reconstructHierarchy(property: DetailProperty, node: MyTreeNode){
    let nodes:MyTreeNode[] = [];
    let treeNodes: MyTreeNode[] = [];

    if (property.PropertyValueSelection){
      property.PropertyValueSelection.forEach(element => {
        nodes.push({
          id: element.SelectionValue,
          title: element.SelectionDisplay,
          isSelected: element.IsSelected,
          parent: element.GroupBy,
          hasChild: element.HasChild
        });
      });

      let isMultiHierarchy: boolean = false;
      if (property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT') isMultiHierarchy = true;

      property.PropertyValueSelection.forEach(element => {
        if (!element.GroupBy) {
          let tree = this.getNestedChildren(nodes, element.SelectionValue, element.IsSelected, isMultiHierarchy);
          treeNodes.push({
            id: element.SelectionValue,
            title: element.SelectionDisplay,
            isSelected: element.IsSelected,
            hasChild: element.HasChild,
            children: tree
          });
        }
      });

      if (treeNodes.length > 0) {
        if (this.lookupArray.find(x => x.name == property.PropertyName)){
          if (treeNodes.length != this.lookupArray.find(x => x.name == property.PropertyName).data.length){
              treeNodes[treeNodes.length - 1].hasLoadMore = true;
            }
        }
      }
      
      let prop = this.detailProperties.find(x=> x.PropertyId == property.PropertyId);
      prop.treeControl.dataNodes = treeNodes;
      // mat-tree has some sort of memory leak issue when not instantiating a new MatTreeNestedDataSource which causes the app to become very slow
      prop.treeDataSource = new MatTreeNestedDataSource<MyTreeNode>();
      prop.treeDataSource.data = treeNodes;

      //need to change the whole process of updating the object
    }
  }

  onSearchHierarchy(keyword: string, property: DetailProperty){
    // if (keyword){
      this.detailService.searchDropdownList(this.componentId, property.PropertyName, keyword).subscribe(result => {
        let lookupList:ValueSelection[] = JSON.parse(result);
        // this.detailService.setTreeData({name: property.PropertyName, data:lookupList});
        // lookupList = lookupList.slice(0, 100);
        if (lookupList){
          this.detailObject.Properties.find(x=> x.PropertyId == property.PropertyId).PropertyValueSelection = lookupList;
          this.constructLookupWithChild(property, lookupList);
          if (property.PropertyValueArray){
            this.getLookupList(property);
          }
        }
      })
  }

  constructLookupWithChild(property: DetailProperty, lookup: any){
    let nodes:MyTreeNode[] = [];
    let treeNodes: MyTreeNode[] = [];
    if (lookup){
      lookup.forEach(element => {
        if (property.PropertyValueArray){
          if(property.PropertyValueArray.indexOf(element.SelectionValue) > -1){
            element.IsSelected = true;
          }
        }

        nodes.push({
          id: element.SelectionValue,
          title: element.SelectionDisplay,
          isSelected: element.IsSelected,
          hasChild: element.HasChild,
          parent: element.GroupBy
        });
      })

      lookup.forEach(element => {
        if (!element.GroupBy) {
          let tree = this.getNestedChildren(nodes, element.SelectionValue, element.IsSelected, property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT');
          treeNodes.push({
            id: element.SelectionValue,
            title: element.SelectionDisplay,
            isSelected: element.IsSelected,
            hasChild: element.HasChild,
            children: tree
          });
        }
      });

      this.getLookupList(property);
      this.detailProperties.find(x=> x.PropertyId == property.PropertyId).PropertyValueSelection = lookup;
      this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeControl.dataNodes = treeNodes;
      this.detailProperties.find(x => x.PropertyId == property.PropertyId).treeDataSource = new MatTreeNestedDataSource<MyTreeNode>();
      this.detailProperties.find(x=> x.PropertyId == property.PropertyId).treeDataSource.data = treeNodes;
    }
  }

  onExpandNode(event: any, property: DetailProperty){
    // fix updating on expand node, should not go through the worst thing again
    let detailProp: DetailProperty = this.detailProperties.find(x => x.PropertyId == property.PropertyId);
    if (detailProp){
      var children = event.node.children;
      if (!children) children = [];
      if(event.isExpanded == true && children.length == 0){
        this.detailService.getLookupList(this.componentId, detailProp.PropertyName, event.node.id).subscribe(result=> {
          let lookupList:ValueSelection[] = JSON.parse(result);
          lookupList = lookupList.map(function(x) { 
            x.GroupBy = event.node.id; 
            return x
          });
          let list = detailProp.PropertyValueSelection;
          lookupList.forEach(element => {
            if (detailProp.PropertyValueSelection.findIndex(x => x.SelectionValue == element.SelectionValue) < 0){
              if (property.PropertyValueArray){
                if (property.PropertyValueArray.findIndex(x => x == element.SelectionValue) > -1) {
                  element.IsSelected = true;
                }
              }
              list.push(element);
            }
          });
          // list = list.concat(lookupList);

          // update hierarchy
          detailProp.PropertyValueSelection = list;
          this.detailService.setTreeData({name: property.PropertyName, data: property.PropertyValueSelection});
          // this.reconstructHierarchy(detailProp, event.node);
          this.updateChildren(detailProp, event.node, lookupList);

        }, error => {
          // prop.PropertyLoadHierarchy = false;
        });
      }
    }
  }

  updateChildren(property: DetailProperty, node: any, newDatanodes: any){
    let prop = this.detailProperties.find(x=> x.PropertyId == property.PropertyId);

    // for (var i = 0;i < prop.treeControl.dataNodes.length; i++){
    //   _node = this.searchInTree(prop.treeControl.dataNodes[i], node.id);
    //   if (_node) break;
    // }
    // console.log(_node);
    // if (_node){
      let isMultiHierarchy: boolean = false;
      if (property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT') isMultiHierarchy = true;
  
      var nodes: MyTreeNode[] = [];
      var valueArray = prop.PropertyValueArray;
      if (!valueArray) valueArray = [];

      newDatanodes.forEach(element => {
        var selected = false;

        if (valueArray.length > 0){
          if (valueArray.indexOf(element.SelectionValue) > -1){
            selected = true;
          }
          else{
            if (isMultiHierarchy){
              selected = node.isSelected;
            }
          }
        }

        nodes.push({
          id: element.SelectionValue,
          title: element.SelectionDisplay,
          isSelected: selected,
          parent: element.GroupBy,
          hasChild: element.HasChild
        });
      });

      var treeNodes = [].concat(prop.treeControl.dataNodes);

      var _node:MyTreeNode = null;
      // var _foundNode = null;
      for (var i = 0;i < treeNodes.length; i++){
        _node = this.searchInTree(treeNodes[i], node.id);
        if (_node) {
          _node.isLoading = false;
          _node.children = nodes;
          break;
        }
      }

      if (_node){
        // treeNodes.push(_node);
        prop.treeControl.dataNodes = treeNodes;
              
        // cdk tree that mat tree is based on has a bug causing children to not be rendered in the UI without first setting the data to null
        prop.treeDataSource.data = null;
        // mat-tree has some sort of memory leak issue when not instantiating a new MatTreeNestedDataSource which causes the app to become very slow
        prop.treeDataSource = new MatTreeNestedDataSource<MyTreeNode>();
        prop.treeDataSource.data = treeNodes;
      }
  
      
    // }
    
  }

  searchInTree(element, id){
    if(element.id == id){
         return element;
    }else if (element.children != null){
      var i;
      var result = null;
      for(i=0; result == null && i < element.children.length; i++){
          result = this.searchInTree(element.children[i], id);
      }
      return result;
    }
    return null;
}

  onCheckedItem($event: MyTreeNode, property: DetailProperty){
    let findProp = this.detailProperties.find(x => x.PropertyId == property.PropertyId);
    let selectedProp = findProp.PropertyValueSelection.find(item => item.SelectionValue == $event.id);
    
    if (selectedProp) selectedProp.IsSelected = !selectedProp.IsSelected;

    if (findProp.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT"){
      if (findProp.PropertyValueArray){
        let addToArray: boolean = false;
        if (findProp.PropertyValueArray.filter(x => x == $event.id).length == 0){
          findProp.PropertyValueArray.push($event.id);
          findProp.PropertyValueDisplayArray.push($event.title);
          addToArray = true;
        }
        else {
          findProp.PropertyValueArray.splice(findProp.PropertyValueArray.findIndex(x => x == $event.id), 1);
          addToArray = false;
        }

        this.pushValueSelection(property);
        
        // add checking to remove child if found parent
        
        // do for both adding and removing items events, adding or removing items will remove all of its child from the parent 
        this.findChild(findProp, $event.id);

      }
      else{
        findProp.PropertyValueArray = [];
        findProp.PropertyValueDisplayArray = [];
        findProp.PropertyValueArray.push($event.id);
        findProp.PropertyValueDisplayArray.push($event.title);
      }
    }
    else if (findProp.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT"){
      if (findProp.PropertyValueArray){
        if (findProp.PropertyValueArray.findIndex(x => x == $event.id) > -1){
          findProp.PropertyValueArray = [];
          findProp.PropertyValueDisplayArray = [];
        }
        else{
          findProp.PropertyValueArray = [];
          findProp.PropertyValueDisplayArray = [];
          findProp.PropertyValueArray.push($event.id);
          findProp.PropertyValueDisplayArray.push($event.title);
        }
      }
      else{
        findProp.PropertyValueArray = [];
        findProp.PropertyValueDisplayArray = [];
      
        findProp.PropertyValueArray.push($event.id);
        findProp.PropertyValueDisplayArray.push($event.title);
        
      }
    }
   
    let array = Object.assign({}, this.detailProperties.find(x => x.PropertyId == property.PropertyId));  //just to trigger angular !

    this.propertyUpdate = array;
  }

  pushValueSelection(property: DetailProperty){
    let prop = this.detailProperties.find(x => x.PropertyId == property.PropertyId);
    if (prop){
      if (prop.PropertyOriginalValueSelection){
        prop.PropertyOriginalValueSelection.forEach(item => {
          if (prop.PropertyValueSelection.filter(x => x.SelectionValue == item.SelectionValue).length == 0){
            prop.PropertyValueSelection.push(item);
          }
          // else{
          //   prop.PropertyValueSelection.splice(prop.PropertyValueSelection.findIndex(x => x.SelectionValue == item.SelectionValue), 1);
          // }
        });
      }
    }
  }

  findChild(property: DetailProperty, id: string){
    // if selected values dont have the item, find if got child
    if (property.PropertyValueArray){
      let selectedItems = property.PropertyValueSelection.filter(x => x.GroupBy.toLowerCase() == id.toLowerCase());
      selectedItems.forEach(element => {
        this.removeChild(property, element.SelectionValue)
      });
    }
    // if (property.PropertyOriginalValueSelection.filter(x => x.GroupBy == id).length > 0){
    //   // if got child
    //   let selectedItems = property.PropertyOriginalValueSelection.filter(x => x.GroupBy == id);

    //   selectedItems.forEach(item => {
    //     this.removeInChild(property, item.SelectionValue);
    //   });
    // }
  }

  removeChild(property, id: string){
    if (property.PropertyValueArray.filter(x => x == id).length > 0){
      // if selected values already have the item
      this.detailProperties.find(x => x.PropertyId == property.PropertyId).PropertyValueArray.splice(property.PropertyValueArray.findIndex(x => x == id), 1);
    }
    else{
      // if selected values dont have the item, find if got child
      if (property.PropertyValueArray){
        let selectedItems = property.PropertyValueSelection.filter(x => x.GroupBy.toLowerCase() == id.toLowerCase());
        selectedItems.forEach(element => {
          this.removeChild(property, element.SelectionValue)
        });
      }
    }
  }

  public onContextMenu($event, item: any): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  getNestedChildren(arr, parentId, isSelected, isMulti: boolean = false) {
    let out = []
    for(let i in arr) {
      if(arr[i].parent.toLowerCase() == parentId.toLowerCase()) {
        let children = null;
        if (isMulti){
          arr[i].isSelected = isSelected ? isSelected : arr[i].isSelected;
          arr[i].isDisabled = isSelected ? isSelected : arr[i].isSelected;
          children = this.getNestedChildren(arr, arr[i].id, isSelected ? isSelected : arr[i].isSelected, isMulti);
        }
        else{
          children = this.getNestedChildren(arr, arr[i].id, arr[i].isSelected, isMulti);
        }

        if(children.length) {
          if (isMulti){
            children.forEach(element => {
              if (arr[i].isSelected){
                element.isSelected = arr[i].isSelected;
                element.isDisabled = arr[i].isSelected;
              }
              else{
                element.isSelected = element.isSelected;
                element.isDisabled = false;
              }
            });
          }
          
          arr[i].children = children;
        }
        out.push(arr[i])
      }
    }
    return out
  }

  // getNestedChildren(arr, parentId, isSelected, isMulti: boolean = false) {
  //   let out = []
  //   for(let i in arr) {
  //     if(arr[i].parent == parentId) {
  //       let children = this.getNestedChildren(arr, arr[i].id, arr[i].isSelected, isMulti);

  //       if(children.length) {
  //         if (isMulti){
  //           children.forEach(element => {
  //             element.isSelected = arr[i].isSelected;
  //             element.isDisabled = arr[i].isSelected;
  //           });
  //         }
          
  //         arr[i].children = children;
  //       }
  //       out.push(arr[i])
  //     }
  //   }
  //   return out
  // }

  constructCombinationProperty(element:DetailProperty) {
    let split = element.PropertyDisplayFormat.split('|');
    let initialColumn = split[0].substring(0, split[0].indexOf('%'));
    let initialColumnWidth = split[0].substring(split[0].indexOf('%') + 1) + "%";
    let secColumn = "";
    let secColumnWidth = ""
    if(split.length > 1){
      secColumn = split[1].substring(0, split[1].indexOf('%'));
      secColumnWidth = split[1].substring(split[1].indexOf('%') + 1) + "%";
    }
    
    let allProperties = [];
    let initialProp = this.hiddenProperties.find(x => x.PropertyName == initialColumn);

    let secProp = this.hiddenProperties.find(x => x.PropertyName == secColumn);

    if (initialProp){
      allProperties.push(initialProp);
    }
    if (secProp){
      allProperties.push(secProp);
    }

    let width = [{initialColumnWidth,secColumnWidth}];
    this.combinationProperty.push({
      combinationId : element.PropertyId,
      properties : allProperties,
      columnWidth: width,
      IsInputLabel: false
    })
  }

  constructSubForm(subForm:any, propertyGroup: DetailPropertyGroup){
    this.subForms[propertyGroup.GroupName] = subForm.form.status;
    subForm.actions.forEach(action => {
      this.subForms[action.ActionCommand] = action.TriggersValidation
    });
  }

  sortProperties(){
    this.detailProperties = this.detailProperties.sort((a:DetailProperty,b:DetailProperty) => { 
      if(a.PropertyOrder > b.PropertyOrder){
        return 1;
      }else if(a.PropertyOrder < b.PropertyOrder){
        return -1;
      }else{
        return 0;
      }
     });
  }

  sortPropertiesByGroup(){
    var properties = this.detailObject.Properties.filter(x => !x.PropertyIsHidden).sort((a:DetailProperty,b:DetailProperty) => { 
      if(a.PropertyOrder > b.PropertyOrder){
        return 1;
      }else if(a.PropertyOrder < b.PropertyOrder){
        return -1;
      }else{
        return 0;
      }
     });

     var propertiesByGroup = [];
     this.groups.forEach(group => {
       propertiesByGroup = propertiesByGroup.concat(properties.filter(x => x.PropertyGroupId == group.GroupId));
     });

     return propertiesByGroup;
  }

  checkIfHasUpdate(){
    if(this.componentId && !this.noLoading){
      this.detailService.checkIfDetailHasUpdate(this.componentId).subscribe(result=>{
        if(result == "1"){
          this.noLoading = true;
          this.getDetailCard();
        }
      }, error => {
          this.sub.unsubscribe();
      })
    }
  }

  onGroupOpened(group: DetailPropertyGroup){
    let expand: boolean = false;
    if (group.InitialLoad){
      this.groups.find(x => x.GroupId == group.GroupId).InitialLoad = false;
    }
    else{
      expand = group.IsExpanded;
      this.groups.find(x => x.GroupId == group.GroupId).IsExpanded = true;  
    }

    if (this.hiddenPropertyFocus){
      setTimeout(() => {
        this.detailService.setPropertyFocus(this.hiddenPropertyFocus.PropertyId);
        this.hiddenPropertyFocus = null;
      },100)
    }

    return expand;
  }

  updateActionsDisplay(){
    let availableSpace: any;
    if ((this.detailObject.DocTitle || this.detailObject.DocSubtitle) && !this.isPopupDetail){
      if ((this.titleElem.nativeElement.offsetWidth / this.detailHeader.nativeElement.offsetWidth * 100) > 70){
        availableSpace = (0.3 * this.detailHeader.nativeElement.offsetWidth) + 50;
      }
      else{
        availableSpace = this.detailHeader.nativeElement.offsetWidth - this.titleElem.nativeElement.offsetWidth - 50;
      }
    }
    else{
        availableSpace = this.detailHeader.nativeElement.offsetWidth;
    }

    if (this.subActionContainer){
      let actionsWidth = this.subActionContainer.nativeElement.offsetWidth;

      actionsWidth = actionsWidth + 44;
  
      if (actionsWidth > availableSpace){
        // move the children to hidden actions
        if (this.hiddenList.length > 0){
          this.render.insertBefore(this.hiddenActions.nativeElement, this.subActionContainer.nativeElement.children[this.subActionContainer.nativeElement.children.length - 1], this.hiddenActions.nativeElement.children[0])
        }
        else{
          this.render.appendChild(this.hiddenActions.nativeElement, this.subActionContainer.nativeElement.children[this.subActionContainer.nativeElement.children.length - 1]);
        }
  
        // record width
        this.hiddenList.push(actionsWidth);
  
        // show the btn
        this.showBtnMore = true;
      }
      else{
        this.moveItemToVisible(availableSpace);
  
        // Hide the dropdown btn if hidden list is empty
        if(this.hiddenList.length < 1) {
          this.showBtnMore = false;
          this.showHidden = false;
        }
      }
  
      // Recur if the visible list is still overflowing the nav
      if(actionsWidth > availableSpace) {
        this.updateActionsDisplay();
      }
    }
    
  }

  moveItemToVisible(availableSpace: number){
    if(availableSpace > this.hiddenList[this.hiddenList.length-1]) {
      // Move the item to the visible list
      this.render.appendChild(this.subActionContainer.nativeElement, this.hiddenActions.nativeElement.children[0]);
      this.hiddenList.pop();

      //recur if still have item that can move to visible list
      this.moveItemToVisible(availableSpace);
    }
  }

  onResized(event){
    if(this.actionsReady && this.displayDetail) this.updateActionsDisplay();
  }

  afterInit(){
    this.actionsReady = true;
    if (this.displayDetail){
      this.updateActionsDisplay();
    }
  }

  onFormInit(){
    if (this.detailForm){
      let obj = {form: this.detailForm, actions: this.detailObject.Actions}
      this.subForm.emit(obj);
      this.detailForm.statusChanges.subscribe(result => {
        let obj = {form: this.detailForm, actions: this.detailObject.Actions}
        this.subForm.emit(obj);
      });
    }
  }

  ngAfterViewInit(){
    if (this.detailForm){
      this.detailForm.statusChanges.subscribe(result => {
        let obj = {form: this.detailForm, actions: this.actions}
        this.subForm.emit(obj);
      });
    }
  }

  ngOnChanges(changes:SimpleChanges)
  {
    //this.isBusy = true;
    //this.getDetailCard();
  }

  onModalScrollDown(event: IInfiniteScrollEvent){
    this.detailScrollPoint = event.currentScrollPosition;
    if (this.isPreview){
      this.next.next();
    }
  }

  groupInit(group: any){
    if (this.previewLoading && this.isPreview){
      if(this.isScrolledIntoView(this.previewLoading.nativeElement)){
        this.getPreviewNextSection(null);
      }
    }
  }

  // getLoadingPosition(el){
  //   console.log(el.offsetParent);
  //   return (el.offsetParent === null);
  // }

  isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}

  getPreviewNextSection(event){

    this.loadingPreview.next(true);
    this.loadingNextPreview = true;
    this.detailService.getPreviewNextSection(this.componentId, "2").subscribe(result => {
      this.loadingPreview.next(false);
      this.loadingNextPreview = false;
      if (result){
        //means there's new group
        let newDetail: Detail = JSON.parse(result);
        let properties = newDetail.Properties.filter(x => x.PropertyOrder != 0).filter(x => !x.PropertyIsHidden);
        this.hiddenProperties = this.hiddenProperties.concat(newDetail.Properties.filter(x => x.PropertyOrder == 0));

        this.detailObject.Groups = [].concat(this.detailObject.Groups);
        this.detailObject.Properties = [].concat(this.detailObject.Properties);

        this.tempDetailProperties = [];
        properties.forEach(element => {
          if (this.detailProperties.find(x => x.PropertyId == element.PropertyId) == null){
            this.tempDetailProperties.push(element);
          }
        });

        this.formatProperties(true);
        this.detailProperties = this.detailProperties.concat(this.tempDetailProperties);

        this.sortProperties();
        
        newDetail.Groups.forEach(element => {
          if (!element.GroupActions) element.GroupActions = [];
          if (this.groups.find(x => x.GroupId == element.GroupId) == null){
            // this.groups.push({...element});
            this.groups.push(Object.assign({}, element));
          }
        });
        // this.sortPropertyGroups();
      }
    }, error => {
      this.loadingPreview.next(false);
      this.loadingNextPreview = false;
      this.lastPreview = true;
    })
  }

  openInNewWindow(){
    console.log(this.router.url)
    window.open(this.router.url, "_blank", "width=600,height=500");
  }

  pin(){
    this.floatingPanelService.pushNewTab(this.componentId, this.detailObject.DocTitle);
  }

  removePin(id: string){
    this.floatingPanelService.removeTab(this.componentId);
  }
}